.scroll {
    position: relative;
    overflow: auto;
    width: 100%;
}

.spacer {
    position: relative;
    width: 100%;
}

.row {
    position: absolute;
    left: 0;
    right: 0;
}

.scroll:focus-visible {
    outline: var(--tempest-focus-ring-width) solid var(--tempest-focus-ring-color);
    outline-offset: 2px;
}
